import { Flex } from "@chakra-ui/layout";

interface PageShellWithThreeColumnsProps {
    centralContent: JSX.Element;
    rightContent?: JSX.Element;
    isOpen?: boolean;
}

export const PageShellWithThreeColumns = (props: PageShellWithThreeColumnsProps) => {
    const { centralContent, rightContent, isOpen } = props;

    return (
        <>
            <Flex
                display={{ base: isOpen ? "none" : "block", md: "block" }}
                p={{ base: "0 3% 2% 3%", sm: "0 1%" }}
                maxW={{ base: 'none', md: '35%' }}
                borderRightWidth={{ lg: "1px", sm: "none" }}
                flex="1"
                flexDirection="column"
                overflow="auto"
                align="stretch"
                h="full"
            >
                {centralContent}
            </Flex>

            <Flex
                display={{ base: isOpen ? "block" : "none", md: "block" }}
                p={{ base: "0 3% 2% 3%", sm: "0 1%" }}
                flex="1"
                width={{ base: 'none', md: "lg" }}
                flexDirection="column"
                overflow="auto"
                align="stretch"
                h="full"
            >
                {rightContent}
            </Flex>
        </>
    );
};